import { render, staticRenderFns } from "./BrandProviderList.vue?vue&type=template&id=ca475704&scoped=true"
import script from "./BrandProviderList.vue?vue&type=script&lang=js"
export * from "./BrandProviderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca475704",
  null
  
)

export default component.exports